import { useCallback, useState } from "react";

/** Keep one live surface while its presentation changes. The outgoing chassis
 * owns its exit clock; only its onExited callback installs the latest requested
 * presentation. A reversal reopens it, and a close cancels any pending arrival. */
export function useSurfacePresentation<T extends string>(
  requested: T,
  open: boolean,
  immediate = false,
) {
  const [state, setState] = useState({
    presentation: requested,
    present: open,
  });

  if (
    (immediate || !state.present) &&
    (state.present !== open || state.presentation !== requested)
  ) {
    setState({ presentation: requested, present: open });
  }

  const onExited = useCallback(() => {
    setState((current) =>
      current.presentation === requested && current.present === open
        ? current
        : { presentation: requested, present: open },
    );
  }, [open, requested]);

  return {
    presentation: state.presentation,
    present: state.present || open,
    open: open && state.presentation === requested,
    onExited,
  };
}
